import * as Yup from 'yup'

export const stylesCreateSchema = Yup.object().shape({
  file: Yup.mixed().nullable(),
  custom_css: Yup.string().nullable(),
})
